module.exports = __webpack_public_path__ + "img/wf-loading-horse.b8897832.gif";